import React, { useState } from "react";
import {
  Image,
  ImageBackground,
  ScrollView,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from "react-native";
import PopUpQuizzLabel from "../../PopUps/PistaQuizzLabel";
import globalstyle from "../../../Styles/Globals/globals";
import style from "../../../Styles/quizz";
import Menu from "../../menu";
import { getRecursText, getRecursURL } from "../../../Functions/getRecurs";

function QuizzLabel(RouterData) {
  const { itinerari, currentItinerari, poi, projecte, recursos, idioma } =
    RouterData.route.params;

  const poiData = itinerari.pois.find((e) => e.id === poi.id);
  const premi = projecte.premis.find((e) => e.id === poiData.premi);
  const [punts, setPunts] = useState(premi?.punts || 100);
  const [numPista, setNumPista] = useState(0);
  const infoPista = poiData["Quizz" + idioma].pistes[numPista];
  const [continuar, setContinuar] = useState(null);
  const [pista, setPista] = useState(false);
  const [resposta, setResposta] = useState("");

  const norm = (text) => {
    if (text && text !== "") {
      return text
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .replace(/[^a-zA-Z0-9]/g, "")
        .toLowerCase();
    } else {
      return "";
    }
  };

  const respondre = () => {
    poiData["Quizz" + idioma].respostes.forEach((element) => {
      // si l'element es all la resposta sera sempre correcte
      if (element.valid === "all") {
        setContinuar(true);
      }

      if (typeof element.valid == "number") {
        if (element.valid === resposta) {
          setContinuar(true);
        } else {
          setPunts(punts - 25);
          setContinuar(false);
        }
      } else {
        if (norm(element.valid) === norm(resposta)) {
          setContinuar(true);
        } else {
          setPunts(punts - 25);
          setPista(true);
          setContinuar(false);
        }
      }
    });
  };

  return (
    <View style={{ flex: 1 }}>
      <ImageBackground
        source={{
          uri: getRecursURL(recursos, "background_default", idioma),
        }}
        style={style.backgroundImatges}
      >
        {/* Pregunta */}
        {pista
          ? PopUpQuizzLabel(
              RouterData,
              pista,
              setPista,
              infoPista,
              numPista,
              setNumPista,
            )
          : null}
        <View
          style={{
            flex: 30,
            justifyContent: "center",
            alignItems: "center",
            alignSelf: "center",
          }}
        >
          <View style={style.questionBackground}>
            <ScrollView
              contentContainerStyle={style.scroll}
              showsHorizontalScrollIndicator={false}
              showsVerticalScrollIndicator={false}
            >
              <View style={{ justifyContent: "center", alignItems: "center" }}>
                <Text style={style.question}>
                  {poiData["Quizz" + idioma].pregunta}
                </Text>
              </View>
            </ScrollView>
          </View>
        </View>
        <View style={{ flex: 5 }} />
        <View
          style={{ flex: 40, justifyContent: "center", alignItems: "center" }}
        >
          <View
            style={{ flex: 30, justifyContent: "center", alignItems: "center" }}
          >
            <TextInput
              style={style.answerInput}
              onChangeText={(text) => setResposta(text)}
              editable={!continuar}
              value={resposta}
            />
          </View>
          <View
            style={{
              flex: 10,
              justifyContent: "center",
              alignItems: "center",
              width: "70%",
              height: "70%",
            }}
          >
            {continuar != null ? (
              <Image
                resizeMode="contain"
                style={style.encert}
                source={{
                  uri: getRecursURL(
                    recursos,
                    continuar ? "resposta_encert" : "resposta_error",
                    idioma,
                  ),
                }}
              />
            ) : null}
          </View>
        </View>
        <View
          style={{ flex: 10, justifyContent: "center", alignItems: "center" }}
        >
          {continuar ? (
            <TouchableOpacity
              onPress={() => {
                currentItinerari.pois.find((e) => e.id == poi.id).punts =
                  punts <= 0 ? 0 : punts;
                RouterData.navigation.navigate(
                  "Premi",
                  RouterData.route.params,
                );
              }}
            >
              <Text style={globalstyle.botoContinuar}>
                {getRecursText(recursos, "text_continuar", idioma)}
              </Text>
            </TouchableOpacity>
          ) : (
            <TouchableOpacity
              onPress={() => {
                respondre();
              }}
            >
              <Text style={globalstyle.botoContinuar}>
                {getRecursText(recursos, "text_respondre", idioma)}
              </Text>
            </TouchableOpacity>
          )}
        </View>
        <View style={{ flex: 5 }} />
        <View style={{ flex: 10 }}><Menu projecte={RouterData.route.params}></Menu></View>
      </ImageBackground>
    </View>
  );
}

export default QuizzLabel;

// {pista ?  PopUpQuizzLabel(RouterData,pista,setPista,infoPista) : null}
